import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { motion } from 'framer-motion';
import { fadeIn } from '../../../shared/helpers/animation';
import FormInputFloat from '../../../shared/components/FormInputFloat';
import { emailValidator } from '../../../shared/helpers/form-validators';
import AnimatedLogoText from '../../../shared/components/AnimatedLogoText';
import Button from '../../../shared/components/Button';
import { useNavigate } from 'react-router-dom';
import PageTransitionWrapper from '../../../shared/components/PageTransitionWrapper';
import useProfileService from '../../../shared/services/useProfileService';
import { showToast } from '../../../shared/store/alerts';
import { useAppDispatch, useAppSelector } from '../../../shared/store/store';
import { CallState, LoadingState, SettingsData, Time } from '../../../shared/types';
import { CancellationToken } from '../../../shared/helpers/CancellationToken';

const NewProfileForm: React.FC<{
  handleCloseModal: () => void;
}> = ({ handleCloseModal }) => {
  
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onTouched',
    defaultValues: {
      firstName: '',
      lastName: '',
      email: "",
      organization: '',
    },
  });
  const profileSvc = useProfileService();

  const apiAddProfile = async (data:any) => {
    const newProfile = await profileSvc.createProfile(data);
    handleCloseModal()
  }

  return (
    <form className="space-y-6" action="#" method="POST">
      <h2 className="mb-8 mt-8 text-2xl font-bold text-primary-light">
        Create Caregiver Account
      </h2>
      <motion.div variants={fadeIn}>
        <FormInputFloat
          label="First name"
          name="firstName"
          control={control}
          rules={{
            required: {
              value: true,
              message: 'First name is required',
            },
          }}
          errors={errors}
        />
      </motion.div>
      <motion.div variants={fadeIn}>
        <FormInputFloat
          label="Last name"
          name="lastName"
          control={control}
          rules={{
            required: {
              value: true,
              message: 'Last name is required',
            },
          }}
          errors={errors}
        />
      </motion.div>
      <motion.div variants={fadeIn}>
        <FormInputFloat
          label="Email"
          name="email"
          control={control}
          rules={{
            required: {
              value: true,
              message: 'Email is required',
            },
          }}
          errors={errors}
        />
      </motion.div>
      <motion.div variants={fadeIn}>
        <FormInputFloat
          label="Name of Organization"
          name="organization"
          control={control}
          errors={errors}
        />
      </motion.div>

      <span className="flex gap-4 w-full">
        <Button
          label="Cancel"
          className="p-button-secondary"
          onClick={handleCloseModal}
        />
        <Button
          label="Create account"
          className="p-button-info w-2/3"
          onClick={handleSubmit((data) => apiAddProfile(data))}
        />
        
      </span>
    </form>
  );
};

export default NewProfileForm;
